/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { sitesUrls } from "§/src/utils/sitesUrls"

function SEO({ seo, lang, langReplace, title, desc }) {
  const { site } = useStaticQuery(
    graphql`
      query SeoQuery {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const metaTitle = title || seo?.title
  const metaDescription = desc || seo?.metaDesc
  const siteUrl = site?.siteMetadata?.siteUrl
  const locale = lang?.locale?.locale
  const translations = lang?.translations
  const ogUrl = translations?.[0]?.href === "/" ? "/en/" : seo?.opengraphUrl || "/"
  const sitesList = sitesUrls("all", translations, langReplace)

  const canonicalUrl = siteUrl + ogUrl
  const alternateUrl = translations?.[0]?.href === "/en/home/" ? "/en/" : translations?.[0]?.href


  return (
    <React.Fragment>
      <title>{metaTitle}</title>

      {sitesList &&
        Object.keys(sitesList)
          .filter(key => key === locale)
          .map(key => (
            <link
              key={key}
              rel="canonical"
              href={canonicalUrl}
            />
          ))}

      {translations &&
        Object.keys(sitesList)
        .filter(key => key !== locale)
          .map(key => (
            <link
              key={key}
              rel="alternate"
              href={siteUrl + (alternateUrl ?? "")}
              hrefLang={key.replace("_", "-")}
            />
          ))}

      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      <meta
        property="og:locale"
        content={locale || "it_IT"}
      />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:site_name" content="cdamedia" />
      <meta property="og:image" content={seo?.opengraphImage?.sourceUrl} />
      <meta property="og:title" content={seo?.opengraphTitle || metaTitle} />
      <meta
        property="og:description"
        content={metaDescription}
      />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo?.twitterTitle || metaTitle} />
      <meta
        name="twitter:description"
        content={metaDescription}
      />
    </React.Fragment>
  )
}

export default SEO
